import { Button, Spinner } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import icUserGroup from '../../assets/img/ic-user-group.svg';

// Purely presentational — all fetching happens once in the parent page via
// useCommunityMembership. Safe to render from both a mobile and a desktop
// section of the same page without ever causing a duplicate lookup request.
const CommunityCta = ({ status, className = '' }) => {
    const navigate = useNavigate();
    const { loading, error, available, conversation, isMember, joining, joinError, join } = status || {};

    if (loading) return null; // avoid a layout jump for a fast, background lookup
    if (error) return null; // non-critical for the detail page; fails silently here
    if (!available) return null; // deactivated/unknown target — do not offer joining

    const handleJoin = async () => {
        const joined = await join();
        if (joined?._id) navigate(`/communities/${joined._id}`);
    };

    return (
        <div className={`community-cta ${isMember && conversation ? '' : 'mb-4'} ${className}`.trim().replace(/\s+/g, ' ')}>
            {isMember && conversation ? (
                <Button
                    variant="outline-primary"
                    size="sm"
                    className="community-cta__button"
                    onClick={() => navigate(`/communities/${conversation._id}`)}
                >
                    <img src={icUserGroup} alt="" className="community-cta__icon" />
                    Open community
                </Button>
            ) : (
                <Button
                    variant="primary"
                    size="sm"
                    className="community-cta__button"
                    onClick={handleJoin}
                    disabled={joining}
                >
                    {joining ? (
                        <Spinner animation="border" size="sm" className="me-1" />
                    ) : (
                        <img src={icUserGroup} alt="" className="community-cta__icon community-cta__icon--light" />
                    )}
                    {joining ? 'Joining…' : 'Join community'}
                </Button>
            )}
            {joinError && <p className="community-cta__error">{joinError}</p>}
        </div>
    );
};

export default CommunityCta;
